import {
  ProductBarProps,
  DSProductBars,
  DSNCDealsLarge,
  DSNCAffilateSection,
  DSResource,
} from 'shared-definitions/types'

export function productBarsMapper<T extends DSResource | DSNCDealsLarge>(
  input: readonly T[]
): DSProductBars & { blocks: readonly (T | DSNCAffilateSection)[] } {
  const productBars: ProductBarProps[] = []
  const blocks = input.flatMap((item): T | T[] | [T, DSNCAffilateSection] => {
    if (item.resource !== 'nc-deals-large') {
      return item
    }

    const newBar = productBarMapper(item as DSNCDealsLarge)
    if (!newBar) {
      return item
    }

    productBars.push(newBar)
    return [item, { resource: 'nc-affilate-section', id: productBars.length - 1 } as const]
  })

  return {
    productBars,
    blocks,
  }
}

function productBarMapper(input: DSNCDealsLarge): ProductBarProps | null {
  const [button] = input.buttons
  if (!button) {
    return null
  }
  return {
    name: input.title,
    score: input.score,
    brand: input.brand ?? '',
    manufacturer: input.subtitle ?? '',
    badge: null,
    button: button.link,
    msrp: input.msrp,
  }
}
